import React from "react";

const ProfileOverview = ({userData}) => {
  // const [userData, setUserData] = useState(null);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // const fetchUserData = async () => {
  //   try {
  //     const data = await fetchUserById(userId);
  //     console.log("data",data)
  //     setUserData(data);
  //   } catch (err) {
  //     setError(err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (userId) {
  //     fetchUserData();
  //   }
  // }, [userId]);

  // if (loading) return <Loader />;
  // if (error) return <Error message={error} />;

  const { name, id, profileUrl, questioner, email } = userData || {};
  const { age, gender, height, weight } = questioner || {};

  return (
    <article className="card">
      <div className="card-body">
        <header className="text-center mb-3">
          <img
            src={profileUrl || "https://via.placeholder.com/150"}
            alt="Profile"
            className="rounded-circle"
            style={{ width: "150px", height: "150px", objectFit: "cover" }}
          />
        </header>
        <section className="row mb-3">
          <div className="col-12 text-center">
            <h5>{name || "K Testing"}</h5>
            <p>User ID: {id || "1"}</p>
          </div>
        </section>
        <section className="row mb-2">
          <div className="col-12 fs-7">Full Name:</div>
          <div className="col-12 fs-7">
            <strong>{name || "K Testing"}</strong>
          </div>
        </section>
        <section className="row mb-2">
          <div className="col-12 fs-7">
            Username:
            <p className="col-12 fs-7">
              <strong>{name || "KTesting"}</strong>
            </p>
          </div>
        </section>
        <section
          className="d-flex justify-content-center mb-2 px-2 py-2 rounded"
          style={{ background: "#CEE2F8" }}
        >
          <div className="fs-7 mx-2">
            Age <span className="fw-bold">{age || "N/A"}</span>
          </div>
          <div className="fs-7 mx-2">
            Gender <span className="fw-bold">{gender || "N/A"}</span>
          </div>
          <div className="fs-7 mx-2">
            Height <span className="fw-bold">{height || "N/A"}</span>
          </div>
          <div className="fs-7 mx-2">
            Weight <span className="fw-bold">{weight || "N/A"}</span>
          </div>
        </section>
        <section className="row mb-2">
          <div className="col-12">
            Email:
            <p className="col-12 fs-6">
              <strong>{email || "testuser2@elitebodyx.in"}</strong>
            </p>
          </div>
        </section>
        <section className="row mb-3 d-flex justify-content-between">
          <div className="col-6 fs-7">
            Subscription Tier: <b>{userData?.subscriptionTier || ""}</b>
          </div>
          <div className="col-6 fs-7">
            Subscription Expiration: <b>DD/MM/YYYY</b>
          </div>
        </section>
        <footer>
          <button className="btn btn-primary w-100">Edit Profile</button>
        </footer>
      </div>
    </article>
  );
};

export default ProfileOverview;
